export const TRACES_DRAWER_INTENT = "tracesDrawer";

export const appendTracesDrawerIntent = (search: string): string => {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  params.set(TRACES_DRAWER_INTENT, "1");
  const next = params.toString();
  return next ? `?${next}` : "";
};

export const appendTracesDrawerIntentToPath = (path: string): string => {
  const [pathWithSearch, hash = ""] = path.split("#");
  const [pathname, search = ""] = pathWithSearch.split("?");
  const nextSearch = appendTracesDrawerIntent(search);
  return `${pathname}${nextSearch}${hash ? `#${hash}` : ""}`;
};

export const stripTracesDrawerIntent = (search: string): string => {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  params.delete(TRACES_DRAWER_INTENT);
  const next = params.toString();
  return next ? `?${next}` : "";
};
